module.exports = __webpack_public_path__ + "img/图片3.4850c6e8.png";